import React, { useContext, useEffect, useMemo, useState } from 'react';
import FourDotLoader from 'components/FourDotLoader';
import { Navigate, useParams } from 'react-router-dom';
import useQueryParams from 'hooks/useQueryParams';
import { BUSINESS_ROUTE } from 'data/global';
import api from 'api';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { useTranslation } from 'react-i18next';
import { getDataRoomRoute } from 'utils';

const ShareableLinkSendPassword: React.FC = () => {
  const [isRequestSent, setIsRequestSent] = useState(false);

  const { shareableLinkId } = useParams<{ shareableLinkId: string }>();
  const {
    params: { emailToken, dataRoomId },
  } = useQueryParams();

  const { popSuccess, popServerError } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const isInvalid = useMemo(
    () => !shareableLinkId || !emailToken,
    [emailToken, shareableLinkId],
  );

  useEffect(() => {
    if (isInvalid) return;

    (async () => {
      try {
        await api.shareableLinks.sendPassword(shareableLinkId, emailToken);
        popSuccess(t('passwordSuccessfullySentToUser'));
      } catch (e) {
        popServerError(e, t('passwordUnsuccessfullySentToUser'));
      } finally {
        setIsRequestSent(true);
      }
    })();
  }, [emailToken, isInvalid, shareableLinkId, popServerError, popSuccess, t]);

  if (isInvalid || isRequestSent)
    return (
      <Navigate
        replace
        to={
          dataRoomId
            ? getDataRoomRoute(dataRoomId, 'shareable-links')
            : BUSINESS_ROUTE
        }
      />
    );

  return <FourDotLoader />;
};

export default ShareableLinkSendPassword;
